<template>
	<div class="table-rate">
		<v-layout row class="border-bottom">
			<v-flex xs8 px-0 py-0 class="filter-table-rate">
				<v-select
					single-line
					hide-details
					class="filter-select mr3 rate-select"
					placeholder="Hotel"
					:items="subsidiaries"
					item-text="name"
					item-value="id"
					v-model="subsidiary"
					@input="$emit('subsidiary-select', subsidiary)"
				>
				</v-select>
			</v-flex>
			<v-flex xs4 px-0 py-0>
				<v-select
					class="filter-select mr3 rate-select"
					hide-details
					placeholder="USD"
					:items="['USD']"
					item-text="name"
					item-value="id"
					v-model="currency"
					single-line
				>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout row class="border-bottom">
			<v-flex xs4 pl-2 d-flex justify-center>ROOM</v-flex>
			<v-flex xs4 px-0 d-flex justify-center class="header-table-rate">Anterior</v-flex>
			<v-flex xs4 px-0 d-flex justify-center>Actual</v-flex>
		</v-layout>
		<v-layout row
			class="border-bottom"
			v-for="(room, indexRoom) in rates.roomType"
			:key="indexRoom"
		>
			<v-flex xs4 pl-2 d-flex justify-start v-if="readOnly">
				<v-btn
					class="btn-save rate-btn"
					@click="selectThisRate(room)"
				>
					{{room.name}}
				</v-btn>
			</v-flex>
			<v-flex xs4 pl-2 d-flex justify-start v-else>{{room.name}}</v-flex>
			<v-flex xs4 pl-2 d-flex justify-center class="header-table-rate">{{room.rateAvailability[0]}}</v-flex>
			<v-flex xs4 px-0 py-0 d-flex justify-center>
				<v-text-field
					:disabled="readOnly"
					class="input-border-inset input-rate-table"
					v-model.number="room.rateAvailability[1]"
					@input="updaterateAvailability"
				/>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
import lib from '@/shared/lib';

const { getPropertysValue, setNewProperty } = lib;

async function loadHotels() {
	const response = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = response.data.data || [];
	const subsidiary = response.data.data[0] ? response.data.data[0].id : 0;
	this.subsidiary = this.selectedSubsidiary || subsidiary;
	if (this.subsidiary > 0) {
		this.loadAllRoomTypes();
	}
}

function mounted() {
	this.loadAllRoomTypes();
	this.loadHotels();
}

async function loadAllRoomTypes() {
	const url = `${process.env.PMS_URL}/roomtype`;
	const { data: roomsTypes } = await this.$http.get(url);
	this.roomsTypes = roomsTypes.data;
	if (this.alreadyExistRate) {
		this.rateAvailability = [...this.rates];
	} else {
		this.buildRateAvailability(this.roomsTypes);
	}
}

function formatRateAvailability(list, item) {
	const newList = [...list];
	const hotelId = getPropertysValue('comSubsidiariesId')(item);
	const type = {
		id: getPropertysValue('id')(item),
		name: getPropertysValue('name')(item),
		rateNew: 0,
		rateAvailability: [0, 0],
	};
	const index = newList.findIndex(h => h.id === hotelId);
	if (index >= 0) {
		newList[index].roomType = newList[index].roomType.concat(type);
		return newList;
	}
	const roomType = [].concat(type);
	return newList.concat({
		id: hotelId,
		roomType,
	});
}

function buildRateAvailability(rooms) {
	this.rateAvailability = rooms.reduce(formatRateAvailability, []);
}

function createRateNewVariable(item) {
	const currentRate = item.rateAvailability[1];
	return setNewProperty('rateNew', currentRate)(item);
}

function filteredSubsidiary() {
	const filteredArray = { ...this.rateAvailability.find(r => r.id === this.subsidiary) };
	if (!this.readOnly && filteredArray && filteredArray.roomType) {
		filteredArray.roomType = filteredArray.roomType.map(createRateNewVariable);
	}
	return filteredArray || {};
}

function updaterateAvailability() {
	const index = this.rateAvailability.findIndex(r => r.id === this.filteredSubsidiary.id);
	this.rateAvailability[index] = { ...this.filteredSubsidiary };
	this.$emit('rate-event', this.rateAvailability);
}

function selectThisRate(roomData) {
	this.$emit('rate-selected', roomData);
}

function data() {
	return {
		currency: 'USD',
		currentSubsidiary: '',
		rateAvailability: [],
		roomsTypes: [],
		subsidiaries: [],
		subsidiary: 0,
	};
}

export default {
	mounted,
	name: 'rate-component',
	computed: {
		filteredSubsidiary,
	},
	data,
	methods: {
		buildRateAvailability,
		createRateNewVariable,
		loadAllRoomTypes,
		loadHotels,
		selectThisRate,
		updaterateAvailability,
	},
	props: {
		alreadyExistRate: {
			default: false,
			type: Boolean,
		},
		selectedSubsidiary: {
			default: null,
			type: Number,
		},
		rates: {
			default: () => {},
			type: [Object, Array],
		},
		readOnly: {
			default: false,
			type: Boolean,
		},
	},
};
</script>
<style lang="scss" scoped>

.table-rate {
	width: 275px;
}

.header-table-rate {
	border-left: 1px solid map-get($colors, e-bg-icon);
	border-right: 1px solid map-get($colors, e-bg-icon);
}

.filter-table-rate {
	border-right: 1px solid map-get($colors, e-bg-icon);
}

.border-bottom {
	border-bottom: 1px solid map-get($colors, e-bg-icon);
}

.rate-btn {
	min-width: 0 !important;
}
</style>




// WEBPACK FOOTER //
// Rate-component.vue?b40dba9e